import React from 'react'

const Card = ({ emoji, heading, detail }) => {
  return (
    <div className='card'>
      <img src={emoji} alt='' />
      <span>{heading}</span>
      <span>{detail}</span>
      <button className='c-button'>Learn more</button>
    </div>
  )
}

export default Card
